<template>
  <md-card>
    <md-card-header>
      <div class="md-layout">
        <div class="md-layout-item md-size-40">
          <h3>Dirección</h3>
        </div>
        <div class="md-layout-item md-size-25 ml-auto">
          <slot name="header"></slot>
        </div>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-50 md-xsmall-size-100">
          <md-field :class="validationClass('state')">
            <label>Estado</label>
            <md-select
              data-vv-name="state"
              v-validate="modelValidations.state"
              v-model="address.state"
            >
              <md-option v-for="state in states" :value="state.id" :key="state.id">{{ state.name }}</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item md-size-50 md-xsmall-size-100">
          <md-field :class="validationClass('municipality')">
            <label>Municipio</label>
            <md-select
              data-vv-name="municipality"
              v-validate="modelValidations.municipality"
              v-model="address.municipality"
            >
              <md-option
                v-for="municipality in municipalities"
                :value="municipality.id"
                :key="municipality.id"
              >{{ municipality.name }}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-size-50 md-xsmall-size-100">
          <md-field :class="validationClass('street')">
            <label>Calle</label>
            <md-input
              data-vv-name="street"
              v-validate="modelValidations.street"
              v-model="address.street"
            ></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-25 md-small-size-100">
          <md-field :class="validationClass('noInt')">
            <label>Número interno</label>
            <md-input
              data-vv-name="noInt"
              v-validate="modelValidations.noInt"
              v-model="address.noInt"
            ></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-25 md-small-size-100">
          <md-field :class="validationClass('noExt')">
            <label>Número externo</label>
            <md-input
              data-vv-name="noExt"
              v-validate="modelValidations.noExt"
              v-model="address.noExt"
            ></md-input>
          </md-field>
        </div>
      </div>

      <!-- :TODO: Add map latitude/longitude  -->

      <div class="md-layout">
        <div class="md-layout-item md-size-50 md-xsmall-size-100">
          <md-field :class="validationClass('postalCode')">
            <label>CP</label>
            <md-input
              data-vv-name="postalCode"
              v-validate="modelValidations.postalCode"
              v-model="address.postalCode"
            ></md-input>
          </md-field>
        </div>

        <div v-if="isFiscalData" class="md-layout-item md-size-50 md-xsmall-size-100">
          <md-field :class="validationClass('colony')">
            <label>Colonia (escriba código postal)</label>
            <md-select
              :disabled="!validCP"
              data-vv-name="colony"
              v-validate="modelValidations.colony"
              v-model="address.colony"
            >
              <md-option
                v-for="item in crolAddresses"
                :value="item.Colonia"
                :key="item.asentamientoId"
              >{{ item.Colonia }}</md-option>
            </md-select>
          </md-field>
        </div>

        <div v-else class="md-layout-item md-size-50 md-xsmall-size-100">
          <md-field :class="validationClass('colony')">
            <label>Colonia</label>
            <md-input
              data-vv-name="colony"
              v-validate="modelValidations.colony"
              v-model="address.colony"
            ></md-input>
          </md-field>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import { mapState } from "vuex";
import usesParentValidatorMixin from "@/mixins/usesParentValidator";
import catalogService from "@/services/catalog";

const modelValidations = {
  state: {
    required: true,
  },
  municipality: {
    required: true,
  },
  street: {
    required: true,
  },
  noInt: {
    required: true,
  },
  colony: {
    required: true,
  },
  postalCode: {
    required: true,
  },
};

export default {
  name: "ContactData",

  mixins: [usesParentValidatorMixin],

  props: {
    address: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    fetchStates: {
      type: Boolean,
      default: true,
    },
    isFiscalData: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      municipalities: [],
      crolAddresses: [],
      modelValidations,
    };
  },

  methods: {
    updateMunicipality() {
      if (!this.address.state) return;
      return catalogService
        .fetch("common/states", this.address.state)
        .then((data) => {
          this.municipalities = data.Municipality;
        });
    },
  },
  computed: {
    ...mapState("catalogs", {
      states: (s) => s["common/states"],
    }),
    validCP() {
      const { postalCode } = this.address;
      return postalCode && postalCode.length === 5 && /^\d+$/.test(postalCode);
    },
  },

  watch: {
    "address.state": function () {
      this.updateMunicipality();
    },
    "address.postalCode": function (v) {
      if (this.validCP && this.isFiscalData) {
        this.address.colony = null;
        return catalogService.fetchColonies(v).then((data) => {
          this.crolAddresses = data;
        });
      }
    },
    "address.colony": function (v) {
      const found = this.crolAddresses.find((c) => c.Colonia === v);
      if (found) {
        this.$emit("setAsentamiento", found.asentamientoId);
      }
    },
  },

  mounted() {
    if (this.fetchStates) {
      catalogService.fetch("common/states");
    }
    if (this.address.state) {
      this.updateMunicipality().then(() =>
        this.watchTouched({ address: Object.keys(this.modelValidations) })
      );
    } else {
      this.watchTouched({ address: Object.keys(this.modelValidations) });
    }
    if (this.address.postalCode && this.isFiscalData) {
      catalogService.fetchColonies(this.address.postalCode).then((data) => {
        this.crolAddresses = data;
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Forms/Address.vue